import { render, staticRenderFns } from "./SweetModalTab.vue?vue&type=template&id=53147251"
import script from "./SweetModalTab.vue?vue&type=script&lang=js"
export * from "./SweetModalTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports